// extracted by css-extract-rspack-plugin
export default {"body":"body-M_47ns","footer":"footer-XAjbls"};